<template>
    <div class="animated fadeIn">
      <h3 class="header-title">Learning EPay</h3>
      <label>Let’s see your tuition EPay.</label>
      <br />
      <div class="custom-explore">
        <div>
          <CRow>
            <CCol sm="12">
              <div style="width: 80%" class="float-left">
                <img
                  src="../assets/img/iconnoti.svg"
                  class="ml-5 mr-2 mb-3 mt-3"
                />
                <span class="text-white mt-3 mb-2"> | </span>
                <label class="ml-2 text-white mt-3 mb-2"
                  >Explore more on your ePay !</label
                >
              </div>
              <div style="width: 20%" class="float-right p-0">
                <br /><br />
                <img
                  src="../assets/img/icontriangle.svg"
                  class="ml-5 mr-2"
                  style="position: absolute;
                    top: 0;
                    right: 100px;
                    bottom: 0;
                    height: 55px;
                  "
                />
              </div>
            </CCol>
          </CRow>
        </div>
      </div>
      <CRow v-if="Busy == true">
        <CCol sm="12" md="12">
          <div class="app flex-row align-items-center">
            <div class="container d-flex justify-content-center">
              <PulseLoader float />
            </div>
          </div>
        </CCol>
      </CRow>
      <template v-else>
       
        <template>
          <div>
            <CCard class="mt-2">
              <br />
              <CInput
              type="text"
              placeholder="Search...."
              v-model.lazy="SearchQuery"
              class="p-2"
            />
            <CRow class="p-2">
                  <CCol sm="3">
                    <div class="custom-form-group">
                      <CInput
                        label="Start Date"
                        type="date"
                        v-model="startDate"
                        class="ml-1 no-border custom-input"
                        :value="startDate || defaultStartDate"
                      />
                    </div>
                  </CCol>
                  <CCol sm="3">
                    <div class="custom-form-group">
                      <CInput
                        label="End Date"
                        type="date"
                        v-model="endDate"
                        class="ml-1 no-border custom-input"
                        :value="endDate || defaultEndDate"
                      />
                    </div>
                  </CCol>
                  <CCol sm="2">
                    <br />
                    <CButton type="button" @click="GetAllTransaction()" color="success" class="mt-2">Search</CButton>
                  </CCol>

                  </CRow>
              <CRow class="m-0">
                <CCol sm="12">
                  <CDataTable
                    :hover="hover"
                    :striped="striped"
                    :bordered="bordered"
                    :small="small"
                    :fixed="fixed"
                    :items="FilterTransactionsList"
                    :fields="fields"
                    items-per-page-select
                    :items-per-page="small ? 5 : 10"
                    :dark="dark"
                    sorter
                    pagination
                  >
                    <template #Teacher="{ item }">
                      <td>
                      {{
                          item.Teacher
                        }}
                      </td>
                    </template>
                    <template #ClassCode="{ item }">
                      <td>
                      {{
                          item.ClassCode
                        }} <br />
                        Date Schedule : {{  item.ScheduleDateTime | moment("DD MMM YYYY HH:mm") }}
                      </td>
                    </template>
                    <template #TeacherAttendance="{ item }">
                      <td>
                        <span v-if="item.IsAttend == 'Yes'"
                          ><CBadge color="success">Yes</CBadge></span
                        >
                        <span v-else><CBadge color="danger">No</CBadge></span>
                      </td>
                    </template>
                    
                    <template #StudentAttendance="{ item }">
                      <td>
                     <ul v-for="items in item.StudentList" v-bind:key="items.Id">
                        <li>{{ items.Name }} <CBadge v-if="items.Attended == true" color="success">Yes</CBadge>
                            <CBadge v-else color="danger">No</CBadge>
                        <br />
                    {{ items.GuidEwallet }}</li>

                     </ul>
                      </td>
                    </template>
                    <template #Action="{ item }">
                      <td>
                        <CButton type="button" @click="OpenStudentAttendance(item)">
                          <CIcon name="cil-pencil" class="mr-3 mt-2"/>
                        </CButton>
                       
                      </td>
                     
                    </template>
                 
                  </CDataTable>
                </CCol>
              </CRow>
            </CCard>


            <CModal
          title="Student Attendance"
          size="lg"
          :show.sync="AttendanceModal"
        >
          <div>
            <h6><strong>DETAIL ATTENDANCE</strong></h6>
            <br />
            <CCol sm="12">
              <CRow>
                Subject Name:

                <CCol sm="12">
                  <CDataTable
                    :small="small"
                    :fixed="fixed"
                    :items="FilteredSchedule"
                    :fields="fieldSchedule"
                    items-per-page-select
                    :items-per-page="small ? 5 : 5"
                    clickable-rows
                    pagination
                    sorter
                    table-filter
                  >
                    <template #Name="{ item }">
                      <td>
                        {{ item.Name }}
                      </td>
                    </template>

                    <template #Attended="{ item }">
                      <td>
                        <span v-if="item.Attended == true"
                          ><CBadge color="success">Yes</CBadge></span
                        >
                        <span v-else><CBadge color="danger">No</CBadge></span>
                      </td>
                    </template>
                    <template #Action="{ item }">
                      <td>
                        <CButton
                          type="button"
                          class="btn btn-success ml-3"
                          @click="UpdateAttendStudent(item)"
                        >
                          Attend</CButton
                        >
                        <CButton
                          type="button"
                          class="btn btn-danger ml-3"
                          @click="UpdateNotAttendStudent(item)"
                        >
                          Not Attend</CButton
                        >
                      </td>
                    </template>
                  </CDataTable>
                </CCol>
              </CRow>
            </CCol>
          </div>
          <template #footer>
            <CButton
              type="submit"
              class="p-2"
              color="info"
              @click="CloseModal()"
              >Proceed</CButton
            ></template
          >
        </CModal>
          </div>
        </template>
      </template>
    </div>
  </template>
  <script>
  import { Switch as cSwitch } from "@coreui/vue";
  import _ from "lodash";
  import Vue from "vue";
  Vue.use(require("vue-moment"));
  import PulseLoader from "vue-spinner/src/PulseLoader.vue";
  
  import vSelect from "vue-select";
  import VuejsDialog from "vuejs-dialog";
  import "vuejs-dialog/dist/vuejs-dialog.min.css";
  Vue.component("v-select", vSelect);
  
  import "vue-select/dist/vue-select.css";
  import "vue-select/src/scss/vue-select.scss";
  Vue.use(VuejsDialog);
  
  export default {
    name: "EPayTransaction",
    components: {
      cSwitch,
      PulseLoader,
    },
    data: function () {
      return {
        Transactions: [],
        FilterTransactions: [],
        Busy: false,
        SearchQuery: "",

        startDate: "",
        endDate: "",
       
        fields: [
          { key: "Teacher" },
          { key: "ClassCode" },
          { key: "TeacherAttendance" },
          { key: "StudentAttendance" },
          { key: "Action" },
        ],
        AttendanceModal: false,
      schedule: [],
      FilteredSchedule: [],
      fieldSchedule: [
        { key: "Name" },
        { key: "Attended" },
        { key: "Action" },
      ],
      };
    },
    async mounted() {
      let isAuth = await this.UserAuth();
  
      if (isAuth) {
        this.GetAllTransaction();
        this.RefreshDataStudent();
      }
      else {
        this.GoToLogin();
      }
    },
    computed: {
      FilterTransactionsList() {
      if(this.SearchQuery === '') return this.FilterTransactions
      return this.FilterTransactions.filter(item => {   
        //teacher name     
        for (const {Name} of item.StudentList) {
          if (
            Name.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1 
          ) {
            return item
          }
        }

      
        //subject name
        if (
            item.Teacher.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1 
          ) {
            return item
          }

          if (
            item.ClassCode.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1 
          ) {
            return item
          }
      })
    
     },
     defaultStartDate() {
        const currentDate = new Date();
        const defaultStartDate = new Date(currentDate.getTime() - 30 * 24 * 60 * 60 * 1000); // 40 days in milliseconds
        return defaultStartDate.toISOString().slice(0, 10); // format as yyyy-mm-dd
      },
      defaultEndDate() {
        const currentDate = new Date();
        return currentDate.toISOString().slice(0, 10); // format as yyyy-mm-dd
      },
    },
    methods: {
    //   async GetAllTransaction() {
    //  this.Busy = true;
    //     return this.$API
    //      .get(this.$GetListEpayTrackData, {
    //         withCredentials: true,
    //       })
    //       .then(
    //         function (response) {
    //             this.Busy = false;
    //           this.Transactions = response.data;
              
    //           this.FilterTransactions = this.Transactions;
  
            
    //         }.bind(this)
    //       )
    //       .catch(function (error) {
    //         console.log(error.response);
    //       });
    //   },
      async GetAllTransaction() {
       
        {
          this.Busy = true;

          if(this.startDate != '' && this.endDate != '')
          {
            return this.$API
         .get(this.$GetListEpayTrackDataByDateRange +
            "?startDate=" + this.startDate + "&endDate=" + this.endDate, {
            withCredentials: true,
          })
          .then(
            function (response) {
                this.Busy = false;
              this.Transactions = response.data;
              
              this.FilterTransactions = this.Transactions;
  
            
            }.bind(this)
          )
          .catch(function (error) {
            console.log(error.response);
          });

          }
          else
          {
            return this.$API
         .get(this.$GetListEpayTrackDataByDateRange +
            "?startDate=" + this.defaultStartDate + "&endDate=" + this.defaultEndDate, {
            withCredentials: true,
          })
          .then(
            function (response) {
                this.Busy = false;
              this.Transactions = response.data;
              
              this.FilterTransactions = this.Transactions;
  
            
            }.bind(this)
          )
          .catch(function (error) {
            console.log(error.response);
          });

          }
       
        }
    
      },
      OpenStudentAttendance(item) {
        this.SubjectId = item.SubjectId;
      this.ScheduleId = item.Id;
   //   this.UpdateRefreshAttendance(this.scheduleId);
   this.GetSchedule(this.SubjectId, this.ScheduleId);
    
    },
    UpdateRefreshAttendance: function (scheduleId) {
      {
        this.scheduleId = scheduleId;
        const formData = new FormData();
        formData.append("scheduleId", this.scheduleId);

        return this.$API
          .post(this.$UpdateRefreshAttendance, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
                this.GetSchedule();
            } else {
            }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      }
    },

    GetSchedule() {
      this.$API
      .get(this.$GetScheduleById + "?subjectId=" + this.SubjectId + "&scheduleId=" + this.ScheduleId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.schedule = response.data;
            this.FilteredSchedule = this.schedule;
            this.AttendanceModal = true;
            
          }
        });
    },
    UpdateAttendStudent: function (item) {
     // this.AttendanceId = item.Id;
      this.ScheduleId = item.ScheduleId;
      this.ManualStudentId = item.ManualStudentId;
       this.UserId = item.UserId;

      const formData = new FormData();
      //formData.append("Id", this.AttendanceId);
      formData.append("ScheduleId", this.ScheduleId);
      formData.append("IsAttending", true);
       formData.append("ManualStudentId", this.ManualStudentId);
         formData.append("UserId", this.UserId);

      return this.$API
        .post(this.$UpdateStudentAttendance, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.RefreshDataStudent();
            //this.AttendanceModal = false;
            //this.$dialog.alert("Success save").then(function () {});
          } else {
            this.Busy = false;
            this.$dialog.alert("Error ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    RefreshDataStudent()
    {
      this.GetSchedule();
      this.GetAllTransaction();
    },
    CloseModal()
    {
      this.AttendanceModal = false;

    },
    UpdateNotAttendStudent: function (item) {
      this.AttendanceId = item.Id;
      this.ManualStudentId = item.ManualStudentId;
      this.ScheduleId = item.ScheduleId;
      const formData = new FormData();
      formData.append("ScheduleId", this.ScheduleId);
      formData.append("IsAttending", false);
      formData.append("ManualStudentId", this.ManualStudentId);

      return this.$API
        .post(this.$UpdateStudentAttendance, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
             this.RefreshDataStudent();
          } else {
            this.Busy = false;
            this.$dialog.alert("Error ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
     
    },
  };
  </script>
  